import {
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  onAuthStateChanged,
} from "firebase/auth";
import { auth } from "./config";

/**
 * Sign in with email and password.
 * Returns a serializable user object (no circular refs).
 */
export const loginWithEmailPassword = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  return serializeUser(userCredential.user);
};

/**
 * Sign out the current user.
 */
export const logoutUser = async () => {
  await signOut(auth);
};

/**
 * Send a password reset email.
 */
export const sendForgotPasswordEmail = async (email) => {
  await sendPasswordResetEmail(auth, email);
};

/**
 * Subscribe to auth state changes.
 * Returns the unsubscribe function.
 */
export const subscribeToAuthChanges = (callback) => {
  return onAuthStateChanged(auth, (user) => {
    callback(user ? serializeUser(user) : null);
  });
};

/**
 * Convert Firebase user to a plain serializable object.
 * Never store the raw Firebase user object in Redux or localStorage.
 */
export const serializeUser = (user) => ({
  uid: user.uid,
  email: user.email,
  displayName: user.displayName || null,
  photoURL: user.photoURL || null,
  emailVerified: user.emailVerified,
});
